angular.module('dpw.components')
    .directive('dpwSsoLogin', ['api', 'firstTimeLogin', function (api, firstTimeLogin) {
        return {
            restrict: 'A',
            scope: {
                ssoUrlApiPath: '@',
                ssoEntryPoint: '@'
            },
            transclude: true,
            templateUrl: 'dpw-sso-login.html',
            bindToController: true,
            controllerAs: 'ssoCtrl',
            controller: [function () {
                var self = this;

                var apiFn = _.get(api, this.ssoUrlApiPath);
                apiFn && api.call(apiFn({
                    entryPoint: self.ssoEntryPoint
                }), function (data) {
                    self.ssoUrl = _.get(data, 'oAuthUrl');
                });

                self.login = function ($event) {
                    self.ssoUrl && popupLoginWindow();

                    function popupLoginWindow() {
                        var popupHeight = 620;
                        window.open(self.ssoUrl, 'ssoLoginWindow',
                            'height=' + popupHeight + ',width=440,left=' + ($event.screenX || 0) + ',top=' + ((screen.height - popupHeight) / 2) +
                            ',resizable=yes,status=yes,scrollbars=yes,toolbar=no,location=no,directories=no,menubar=no,copyhistory=no');
                    }
                };
            }]
        }
    }]);